import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=e88cfdbe&scoped=true&"
var script = {}
import style0 from "./BackButton.vue?vue&type=style&index=0&id=e88cfdbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88cfdbe",
  null
  
)

export default component.exports